import { Scroll, Stack } from '@/components/layout';
import { Button } from '@/components/ui';
import { Text } from '@/components/ui/text';
import { useDevelopmentStackNavigation } from '@/hooks/use-navigation';
import { theme } from '@/theme/theme';
import { StyleSheet } from 'react-native';
import { KeyboardAvoidingView } from 'react-native-keyboard-controller';

/**
 * Development screen
 * This screen is used for development purposes only
 * @returns Development screen component
 */
export function DevelopmentScreen() {
  const navigation = useDevelopmentStackNavigation();
  return (
    <KeyboardAvoidingView behavior="padding" style={styles.root}>
      <Scroll safeArea align="center" justify="center" width="100%" flexGrow={1}>
        <Stack paddingX={16} gap={16} flex={1} align="center" justify="center">
          <Text>Development screen</Text>
          <Button onPress={() => navigation.navigate('Component')}>
            <Button.Text>Open component screen</Button.Text>
          </Button>

          <Button onPress={() => navigation.goBack()}>
            <Button.Text>Go back</Button.Text>
          </Button>
        </Stack>
      </Scroll>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: theme.colors['Backgrounds/Primary'],
    alignItems: 'center',
    justifyContent: 'center',
  },
});
